import headerSocialIconsActiveRule from '../../../common/algorithms/header-social-icons-active-rule';

const secondary = (params) => headerSocialIconsActiveRule(params);

export default secondary;
